<template>
  <div class="page">
    <div class="container">
      <div class="article-form-wrapper">
        <!-- 页面标题 -->
        <div class="page-title" @click="goBack" code-stm="event, PAGEURL, 新建文章返回"><span class="page-title-icon"> &lt; </span>新建文章</div>

        <!-- 表单内容 -->
        <div class="article-form">
          <!-- 第一个模块：上传封面图 -->
          <div class="form-section">
            <div class="form-label required">上传封面图</div>
            <div class="cover-upload-area">
              <div class="cover-upload-wrapper" :class="{ 'has-image': coverImage }">
                <ImageUpload
                  v-model="formData.mainImg"
                  ref="coverUploadRef"
                  :uploadImgUrl="uploadImgUrl"
                  :limit="1"
                  :imgKind="'cover'"
                  :headers="headers"
                  upload-img-type="community"
                  :fileSize="5"
                  :fileType="['jpg', 'png']"
                  @input="handleCoverImageUpdate"
                >
                </ImageUpload>
                <!-- 图片预览区域 -->
                <div class="cover-preview" v-if="coverImage">
                  <img :src="coverImage" alt="封面预览" />
                  <div class="cover-preview-mask">
                    <i
                      class="el-icon-zoom-in"
                      title="查看大图"
                      @click.stop="openCoverPreview"
                    ></i>
                    <i
                      class="el-icon-delete"
                      title="删除"
                      @click.stop="removeCover"
                    ></i>
                  </div>
                </div>
              </div>
              <!-- 封面大图预览：使用 el-image 内置预览功能 -->
              <el-image
                v-if="coverImage"
                ref="coverPreviewImage"
                :src="coverImage"
                :preview-src-list="[coverImage]"
                style="display: none"
              />
              <div class="form-note">
                备注:上传您想分享的一张图片(必填),支持格式:jpg、png,单个文件不能超过5MB
              </div>
            </div>
          </div>

          <!-- 第二个模块：文章标题 -->
          <div class="form-section">
            <div class="form-label required">文章标题</div>
            <div class="title-input-wrapper">
              <el-input
                v-model="formData.title"
                placeholder="请输入标题"
                maxlength="20"
                show-word-limit
                class="title-input"
              ></el-input>
            </div>
          </div>

          <!-- 第三个模块：文章正文 -->
          <div class="form-section">
            <div class="form-label required">
                <div class="form-label-title">文章正文</div>
                <div class="form-note-text">
                备注:100字+3图以上有机会被更多人看到哦!字数不超过5000,图片不超过9张,最少上传1张。
              </div>
            </div>
            <div class="content-input-wrapper">
              <WangEditor
                v-model="formData.content"
                :preText="preText"
                :token="headers.Token || ''"
                :maxImageCount="9"
                :initValue="formData.content"
                :placeholder="'请输入正文'"
                :toolbarTip="'备注：上传图片支持格式:jpg、.png，单个文件不能超过5MB，最多上传9张图片，最少上传1张图片。'"
                @getEditorContent="handleEditorContent"
                @imageCountChange="handleImageCountChange"
                @input="handleContentInput"
                class="content-editor"
              ></WangEditor>
              <!-- <div class="editor-tips">
                备注：上传图片支持格式:jpg、.png，单个文件不能超过5MB，最多上传9张图片，最少上传1张图片。
              </div> -->
            </div>
          </div>
        </div>

        <!-- 提交按钮

        :class="{
            'submit-btn-wrapper--fixed': isMobile && !isButtonAbsolute,
            'submit-btn-wrapper--absolute': isMobile && isButtonAbsolute,
          }"
        -->

        <div
          class="submit-btn-wrapper"

        >
          <el-button
            type="primary"
            class="submit-btn"
            @click="handleSubmit"
            :loading="isSubmitting"
            :disabled="!canSubmit"
            code-stm="event, PAGEURL, 文章提交按钮"
          >
            提 交
          </el-button>
        </div>
      </div>
    </div>

    <!-- 提交结果弹窗 -->
    <Popup
      :visible="popupVisible"
      :title="popupInfo.title"
      :content="popupInfo.content"
      :button-text="popupInfo.button || popupInfo.type || '确定'"
      @close="closePopup"
      @confirm="handlePopupConfirm"
    />

    <!-- 提交文章：全屏 loading（pc + mob） -->
    <div v-if="isSubmitting" class="fullscreen-loading">
      <div class="fullscreen-loading__spinner"></div>
      <div class="fullscreen-loading__text">提交中…</div>
    </div>
  </div>
</template>

<script>
import { queUrl } from "@/config/base";
import ImageUpload from "@/components/ImageUpload/index";
import WangEditor from "@/components/community/wangEditor";
import Popup from "@/components/community/popup";
import { utf8_to_b64 } from "@/utils/utils.js";

export default {
  name: "articleCreate",
  components: {
    ImageUpload,
    WangEditor,
    Popup,
  },
  data() {
    const ua = navigator.userAgent || "";
    const initialIsMobile =
      window.innerWidth <= 768 || /Mobile|Android|iP(hone|od|ad)/i.test(ua);
    return {
      formData: {
        mainImg: "", // 封面图（使用ImageUpload组件，格式：{img: 'url', imgKind: 'cover'}）
        title: "",
        content: "", // 富文本内容（HTML格式）
      },
      coverImage: "", // 封面图预览URL
      isSubmitting: false,
      preText: "https://www.kia.cn",
      headers: {},
      uploadImgUrl: `${queUrl}interface/ossClient/upload`,
      editorImageCount: 0, // 富文本编辑器中的图片数量
      minEditorImageCount: 1, // 富文本编辑器最少图片数量（可配置）
      isMobile: initialIsMobile,
      // 移动端：底部提交按钮滚动到 Footer 时改为 absolute，避免遮挡
      isButtonAbsolute: false,
      popSuccessInfo: {
        title: "提交成功",
        content: "您编辑的内容已成功提交审核，感谢您的分享！",
        button: "我知道了",
      },
      popErrorInfo: {
        title: "内容审核不通过",
        content: "您提交内容中含有禁止内容，请修改后重新提交",
        type: "返回修改",
      },
      popupVisible: false,
      popupInfo: {},
    };
  },
  computed: {
    canSubmit() {
      // 验证表单是否可提交
      const hasMainImg = this.coverImage || (this.formData.mainImg && this.formData.mainImg.img);
      // 检查富文本内容（去除HTML标签后的纯文本长度）
      const textContent = this.formData.content ? this.formData.content.replace(/<[^>]+>/g, '').trim() : '';
      return (
        hasMainImg &&
        this.formData.title.trim() &&
        textContent.length > 0 &&
        this.editorImageCount >= this.minEditorImageCount
      );
    },
  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }

    // 判断是否为移动端
    const ua = navigator.userAgent || "";
    this.isMobile =
      window.innerWidth <= 768 ||
      /Mobile|Android|iP(hone|od|ad)/i.test(ua);

    // 移动端：监听滚动，参考 detail.vue 的吸底按钮逻辑
    if (this.isMobile) {
      window.addEventListener("scroll", this.handleSubmitButtonScroll, { passive: true });
      this.$nextTick(() => {
        this.handleSubmitButtonScroll();
      });
    }

    // 初始化 headers
    this.headers = {
      Token: this.getToken(),
    };
  },
  beforeDestroy() {
    if (this.isMobile) {
      window.removeEventListener("scroll", this.handleSubmitButtonScroll);
    }
  },
  methods: {
    getToken() {
      var getUserInfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      if (!getUserInfo) {
          return '';
      }
      return getUserInfo.token || '';
    },
    goBack() {
      if (this.$router && typeof this.$router.back === "function") {
        this.$router.back();
      } else if (this.$router && typeof this.$router.go === "function") {
        this.$router.go(-1);
      }
    },
    // Header-co 会 emit forbid/open；这里做兜底，避免触发时报错
    forbid() {},
    open() {},
    // 监听页面滚动：当 Footer 进入视口时，移动端按钮由 fixed 变为 absolute，避免压住 Footer
    handleSubmitButtonScroll() {
      if (!this.isMobile) return;
      try {
        const footer = document.getElementById("page1");
        if (!footer || typeof footer.getBoundingClientRect !== "function") {
          this.isButtonAbsolute = false;
          return;
        }
        const rect = footer.getBoundingClientRect();
        const viewportHeight =
          window.innerHeight || document.documentElement.clientHeight || 0;
        // 关键：判断"Footer 是否会被吸底按钮遮挡"，而不是"Footer 是否进入视口"
        // 吸底按钮高度（拿不到时给一个兜底值，避免初始化误判）
        const submitBarEl =
          (this.$el && this.$el.querySelector && this.$el.querySelector(".submit-btn-wrapper")) ||
          null;
        const submitBarHeight =
          (submitBarEl && submitBarEl.getBoundingClientRect && submitBarEl.getBoundingClientRect().height) ||
          0;
        const safePadding = 8; // 预留一点间距，避免临界抖动
        this.isButtonAbsolute = rect.top <= viewportHeight - safePadding;
      } catch (e) {
        this.isButtonAbsolute = false;
      }
    },
    // 处理封面图更新（ImageUpload组件的input事件）
    handleCoverImageUpdate(value) {
      this.formData.mainImg = value;
      // 从ImageUpload组件返回的数据中提取图片URL
      // ImageUpload组件返回格式：{img: 'url1,url2', imgKind: 'cover'}
      // img 是逗号分隔的URL字符串，可能是相对路径或完整URL
      if (value && value.img) {
        // 取第一个URL
        const imgUrl = value.img.split(',')[0].trim();
        if (imgUrl) {
          // 如果URL不是完整路径，需要添加baseUrl（与ImageUpload组件内部逻辑一致）
          if (!imgUrl.startsWith('http://') && !imgUrl.startsWith('https://')) {
            const baseUrl = process.env.VUE_APP_BASE_API || '';
            this.coverImage = baseUrl + imgUrl;
          } else {
            this.coverImage = imgUrl;
          }
        } else {
          this.coverImage = "";
        }
      } else {
        this.coverImage = "";
      }
    },
    // 移除封面图
    removeCover() {
      if (this.$refs.coverUploadRef) {
        this.$refs.coverUploadRef.clearnFileList();
      }
      this.coverImage = "";
      this.formData.mainImg = "";
    },
    // 查看封面大图
    openCoverPreview() {
      // 触发 el-image 的点击，从而打开预览大图
      this.$nextTick(() => {
        const vm = this.$refs.coverPreviewImage;
        const el = vm && vm.$el;
        const img = el && el.querySelector("img");
        if (img && typeof img.click === "function") {
          img.click();
        }
      });
    },
    // 处理富文本编辑器内容变化
    handleContentInput(value) {
      this.formData.content = value;
    },
    // 处理富文本编辑器内容（children和HTML）
    handleEditorContent(children, html) {
      // 可以在这里处理编辑器的内容
      // children 是编辑器节点树，html 是HTML字符串
    },
    // 处理富文本编辑器图片数量变化
    handleImageCountChange(count) {
      this.editorImageCount = count;
    },
    openPopup(info) {
      this.popupInfo = info || {};
      this.popupVisible = true;
    },
    closePopup() {
      this.popupVisible = false;
    },
    handlePopupConfirm() {
      this.closePopup();
      this.goBack()
    },
    // 提交表单
    async handleSubmit() {
      if (!this.canSubmit) {
        this.$message.warning("请完善必填信息");
        return;
      }

      // 验证图片数量（从富文本编辑器中统计）
      if (this.editorImageCount < this.minEditorImageCount) {
        this.$message.warning(`至少需要上传${this.minEditorImageCount}张图片`);
        return;
      }

      this.isSubmitting = true;

      try {
        const coverImg =
          (this.formData.mainImg && this.formData.mainImg.img
            ? this.formData.mainImg.img.split(",")[0].trim()
            : "") || "";

        const payload = {
          content: utf8_to_b64(this.formData.content),
          mainImg: coverImg,
          title: this.formData.title,
        };

        const res = await this.$axios.post(
          `${queUrl}interface/community/client/saveArticle`,
          payload,
          { headers: this.headers }
        );

        if (res && res.data && res.data.code == 200) {
          this.openPopup(this.popSuccessInfo);
          this.formData = {
            mainImg: "",
            title: "",
            content: "",
          };
          this.coverImage = "";
          this.editorImageCount = 0;
        } else {
          const msg = (res && res.data && (res.data.msg || res.data.message)) || "";
          if (msg === "文本检测违规" || msg === "图片检测违规") {
            this.openPopup(this.popErrorInfo);
          } else {
            this.$message.error(msg || "提交失败，请重试");
          }
        }
      } catch (error) {
        this.$message.error("提交失败，请重试");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f2f2f2;
  min-height: 100vh;
}

.container {
  min-height: 100vh;
  display: flex;
  @media (min-width: 768px) {
    padding: 90px 0 calc(78 / 1920 * 100vw);
    width: calc(1160 / 1920 * 100vw);
    margin: 0 auto;
  }
  @media (max-width: 768px) { /* 移动端 */
    padding: 60px 0 0;
    width: 100%;
    margin: 0 auto;
  }
}

.article-form-wrapper {
  width: 100%;
  position: relative;
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 calc(38 / 750 * 100vw);
    // 给吸底按钮预留空间，避免遮挡内容
    padding-bottom: calc(200 / 750 * 100vw);
  }
}

.page-title {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(28 / 1920 * 100vw);
  color: #000;
  margin-top: calc(15 / 1920 * 100vw);
  margin-bottom: calc(15 / 1920 * 100vw);
  cursor: pointer;
  span {
    color: #00000080;
    margin-right: calc(20 / 1920 * 100vw);
  }
  @media (max-width: 768px) {
    font-size: calc(35 / 750 * 100vw);
    margin-top: calc(44 / 750 * 100vw);
    margin-bottom: calc(44 / 750 * 100vw);
  }
}

.article-form {

  @media (max-width: 768px) {
  }
}

.form-section {
  background-color: #fff;
  border-radius: calc(5 / 1920 * 100vw);
  padding: calc(20 / 1920 * 100vw)  calc(40 / 1920 * 100vw);
  margin-bottom: calc(20 / 1920 * 100vw);
  @media (max-width: 768px) {
    margin-bottom: calc(40 / 750 * 100vw);
    padding: calc(40 / 750 * 100vw) calc(35 / 750 * 100vw);
    border-radius: calc(8 / 750 * 100vw);
  }
  &:last-of-type {
    margin-bottom: 0;
  }
}

.form-label {
    display: flex;
    align-items: center;
  font-family: "FZLanTingHeiS-DB-GB";
  font-size: calc(20 / 1920 * 100vw);
  color: #585858;
  margin-bottom: calc(17 / 1920 * 100vw);
  @media (max-width: 768px) {
    flex-wrap: wrap;
    font-size: calc(31 / 750 * 100vw);
     margin-bottom: calc(38 / 750 * 100vw);
  }
  &.required::before {
    content: "*";
    color: #585858;
    margin-right: calc(4 / 1920 * 100vw);
  }
}
.form-label-title {
    flex: 1;
}

// 封面图上传
.cover-upload-area {
  .cover-upload-wrapper {
    position: relative;
    display: inline-block;
    // 自定义 ImageUpload 组件样式，保持现有样式
    ::v-deep .component-upload-image {
      .file-uploader {
        .el-upload--picture-card {
          width: calc(97 / 1920 * 100vw) !important;
          height: calc(97 / 1920 * 100vw) !important;
          border: none;
          background-color: #F7F8F9;
          border-radius: calc(4 / 1920 * 100vw);
          line-height: calc(300 / 1920 * 100vw);
          @media (max-width: 768px) {
            width: calc(143 / 750 * 100vw) !important;
            height: calc(143 / 750 * 100vw) !important;
            border-radius: calc(4 / 750 * 100vw);
            line-height: calc(143 / 750 * 100vw);
          }
          &:hover {
            border-color: #409eff;
          }
          .avatar-uploader-icon {
            font-size: calc(27 / 1920 * 100vw);
            color: #000000;
            @media (max-width: 768px) {
              font-size: calc(40 / 750 * 100vw);
            }
          }
        }
        .el-upload-list--picture-card {
          display: none; // 隐藏默认的上传列表，使用自定义预览区域
        }
      }
    }
    // 当有图片时隐藏上传按钮
    &.has-image {
      ::v-deep .component-upload-image {
        .file-uploader {
          .el-upload--picture-card {
            display: none;
          }
        }
      }
    }
    // 图片预览区域
    .cover-preview {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
      width: calc(97 / 1920 * 100vw);
      height: calc(97 / 1920 * 100vw);
      border-radius: calc(4 / 1920 * 100vw);
      overflow: hidden;
      background-color: #F7F8F9;
      z-index: 10;
      @media (max-width: 768px) {
        width: calc(300 / 750 * 100vw);
        height: calc(300 / 750 * 100vw);
        border-radius: calc(4 / 750 * 100vw);
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
      .cover-preview-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: calc(12 / 1920 * 100vw);
        cursor: pointer;
        transition: background-color 0.3s;
        &:hover {
          background-color: rgba(0, 0, 0, 0.5);
          i {
            opacity: 1;
          }
        }
        i {
          font-size: calc(20 / 1920 * 100vw);
          color: #fff;
          opacity: 0;
          transition: opacity 0.3s;
          padding: calc(6 / 1920 * 100vw);
          border-radius: 50%;
          @media (max-width: 768px) {
            font-size: calc(30 / 750 * 100vw);
            padding: calc(10 / 750 * 100vw);
          }
        }
      }
    }
  }
}

// 文章标题
.title-input-wrapper {
  .title-input {
    ::v-deep .el-input__inner {
      font-family: "FZLanTingHeiS-R-GB";
      font-size: calc(19 / 1920 * 100vw);
      border: none;
      padding: 0;
      @media (max-width: 768px) {
        font-size: calc(28 / 750 * 100vw);
      }
    }
  }
}

// 文章正文
.content-input-wrapper {
    position: relative;
  .content-editor {
    font-family: "FZLanTingHeiS-R-GB";
    // display: flex;
    // flex-direction: column-reverse;
    border: none !important;
    ::v-deep .w-e-text-container {
      font-size: calc(16 / 1920 * 100vw);
      line-height: 1.6;
      /* 仅设置最小高度，让内容自动撑开，不出现内部滚动条 */
      min-height: calc(300 / 1920 * 100vw);
      @media (max-width: 768px) {
        font-size: calc(28 / 750 * 100vw);
      }
    }
    ::v-deep .w-e-text-placeholder {
      font-family: "FZLanTingHeiS-R-GB";
      font-size: calc(16 / 1920 * 100vw);
      font-style: normal !important;
      @media (max-width: 768px) {
        font-size: calc(28 / 750 * 100vw);
      }
    }
    ::v-deep .w-e-hover-bar {
      display: none;
    }
    &:last-child {
        border: none !important;
    }
  }
  .editor-tips {
    position: absolute;
    bottom: calc(8 / 1920 * 100vw);
    left: calc(68 / 1920 * 100vw);
    z-index: 10;
    font-family: "FZLanTingHeiS-R-GB";
    font-size: calc(15 / 1920 * 100vw);
    color: #00000066;
    @media (max-width: 768px) {
        font-size: calc(24 / 750 * 100vw);
    }
  }
}

.form-note {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(14 / 1920 * 100vw);
  color: #0000004D;
  margin-top: calc(20 / 1920 * 100vw);
  line-height: calc(37 / 1920 * 100vw);
  @media (max-width: 768px) {
    font-size: calc(21 / 750 * 100vw);
    margin-top: calc(24 / 750 * 100vw);
    line-height: calc(30 / 750 * 100vw);
  }
}

.form-note-text {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(14 / 1920 * 100vw);
  color: #0000004D;
  @media (max-width: 768px) {
    font-size: calc(21 / 750 * 100vw);
    padding: calc(23 / 750 * 100vw) 0;
    border-bottom: 1px solid #0000001A;
  }
}

// 提交按钮
.submit-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: calc(20 / 1920 * 100vw);
  .el-button {
    width: calc(143 / 1920 * 100vw);
    height: calc(45 / 1920 * 100vw);
    border-radius: calc(4 / 1920 * 100vw);
    font-size: calc(18 / 1920 * 100vw);
    padding: 0;
    text-align: center;
    line-height: calc(45 / 1920 * 100vw);
  }
  @media (max-width: 768px) {
    z-index: 2;
    width: 100%;
    box-sizing: border-box;
    margin-top: calc(80 / 750 * 100vw);
    margin-bottom: calc(40 / 750 * 100vw);
    .el-button  {
        width: 100%;
        height: calc(100 / 750 * 100vw);
        font-size: calc(32 / 750 * 100vw);
    }
  }
}

.fullscreen-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}
.fullscreen-loading__spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  animation: fullscreenSpin 0.9s linear infinite;
}
.fullscreen-loading__text {
  margin-top: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  font-family: "FZLanTingHeiS-R-GB";
}
@keyframes fullscreenSpin {
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  // Footer 进入视口后：按钮回到表单区域底部
  .submit-btn-wrapper.submit-btn-wrapper--absolute {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
}

// 移动端吸底悬浮（JS 判断，避免依赖 viewport meta 导致媒体查询失效）
.submit-btn-wrapper.submit-btn-wrapper--fixed {
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    width: 100%;
    box-sizing: border-box;
    padding: calc(52 / 750 * 100vw);
    background-color: #fff;
    // border-top: 1px solid #E8E8E8;
    margin-top: 0;
    margin-bottom: 0;
  }
}

// 移动端到位停靠（JS 判断）
.submit-btn-wrapper.submit-btn-wrapper--absolute {
  @media (max-width: 768px) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: calc(50 / 750 * 100vw) calc(30 / 750 * 100vw);
    // background-color: #fff;
    // border-top: 1px solid #E8E8E8;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.submit-btn {
  font-family: "FZLanTingHeiS-R-GB";
  font-size: calc(16 / 1920 * 100vw);
  padding: calc(12 / 1920 * 100vw) calc(40 / 1920 * 100vw);
  background-color: #000;
  border-color: #000;
  @media (max-width: 768px) {
    font-size: calc(28 / 750 * 100vw);
    padding: calc(16 / 750 * 100vw) calc(50 / 750 * 100vw);
  }
  &:hover {
    background-color: #333;
    border-color: #333;
  }
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }
}
</style>
